import React from "react";
import RestaurantContractText from "./RestaurantContractText";
import { CONTRACT_PARTY_FIELDS, TAX_CONDITIONS, REPRESENTATIVE_CAPACITIES } from "../../services/local/restaurantContract";
import "../../styles/RestaurantContract.css";

export default function RestaurantContractAcceptance({ document, party, onPartyChange, accepted, authority,
  onAcceptedChange, onAuthorityChange, disabled, email }) {
  return <section className="restaurant-contract" aria-labelledby="restaurant-contract-title">
    <h2 id="restaurant-contract-title">Contratacion del servicio</h2>
    <div className="restaurant-contract__fields">
      {CONTRACT_PARTY_FIELDS.map(([key, label]) => <label key={key}>{label}
        <input value={party[key] || ""} maxLength={500} required disabled={disabled}
          onChange={(event) => onPartyChange(key, event.target.value)} />
      </label>)}
      <div className="restaurant-contract__field">
        <label htmlFor="contract-tax-condition">Condicion fiscal</label>
        <select id="contract-tax-condition" value={party.taxCondition || ""} required disabled={disabled} onChange={(event) => onPartyChange("taxCondition", event.target.value)}>
          <option value="">Seleccionar</option>
          {TAX_CONDITIONS.map(([id, label]) => <option key={id} value={id}>{label}</option>)}
        </select>
      </div>
      <div className="restaurant-contract__field">
        <label htmlFor="contract-representative-capacity">Caracter del representante</label>
        <select id="contract-representative-capacity" value={party.representativeCapacity || ""} required disabled={disabled} onChange={(event) => onPartyChange("representativeCapacity", event.target.value)}>
          <option value="">Seleccionar</option>
          {REPRESENTATIVE_CAPACITIES.map(([id, label]) => <option key={id} value={id}>{label}</option>)}
        </select>
      </div>
    </div>
    <p>Correo contractual: <strong>{email}</strong></p>
    <details open>
      <summary>{document.title} / Version {document.version}</summary>
      <RestaurantContractText text={document.bodyText} />
    </details>
    <label className="restaurant-contract__check">
      <input type="checkbox" data-contract-consent="true" checked={authority} disabled={disabled}
        onChange={(event) => onAuthorityChange(event.target.checked)} />
      <span>Declaro ser titular o representante autorizado del restaurante.</span>
    </label>
    <label className="restaurant-contract__check">
      <input type="checkbox" data-contract-consent="true" checked={accepted} disabled={disabled}
        onChange={(event) => onAcceptedChange(event.target.checked)} />
      <span>Lei y acepto el contrato de MozzoApp y sus anexos para este restaurante.</span>
    </label>
  </section>;
}
